import { Box, Center, Image, Stack } from "@chakra-ui/react";
import * as React from "react";

import { assetUrl } from "../lib/brand";
import { Logo } from "./logo";

export const AuthHero = () => (
  <Box flex="1" hideBelow="lg">
    <Center w="full" h="full">
      <Stack align="center" gap="1">
        <Logo width="3xs" />
        <Image src={assetUrl("auth-hero.png")} w="md" />
      </Stack>
    </Center>
  </Box>
);
